import React from 'react';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import Link, { linkBase } from '@src/mobile/components/Link';
import styles from './index.css';
import { Store } from '../store';

const cx = classNames.bind(styles);

const List = () => {
    const store = Store.useContainer();
    const { states } = store;
    const { list, navHeight, showFixedNav } = states;

    return (
        <>
            <div className={cx('listHead', { listHeadFixed: showFixedNav })} style={{ top: navHeight - 2 }}>
                <div className={styles.row}>
                    <div className={styles.rank}>排名</div>
                    <div className={styles.country}>国家/地区</div>
                    <div className={styles.gold}>金</div>
                    <div className={styles.silver}>银</div>
                    <div className={styles.copper}>铜</div>
                    <div className={styles.sum}>总计</div>
                </div>
            </div>
            <div className={styles.wrap}>
                <div className={styles.listBody}>
                    {list.map((item, index) => {
                        const { country, goldNum, silverNum, copperNum, total, url, rank } = item;
                        // 是否是中国
                        const isChina = country === '中国';
                        // 是否是前三名
                        const isTopThree = index < 3;

                        const itemInner = (
                            <div className={styles.row}>
                                <div className={cx('rank', { rankTopThree: isTopThree })}>{rank}</div>
                                <div className={styles.country}>
                                    <div className={styles.countryFlag}>
                                        <LazyImg src={url} alt="" />
                                    </div>
                                    <div className={styles.countryName}>{country}</div>
                                </div>
                                <div className={styles.gold}>{goldNum}</div>
                                <div className={styles.silver}>{silverNum}</div>
                                <div className={styles.copper}>{copperNum}</div>
                                <div className={styles.sum}>{total}</div>
                            </div>
                        );

                        return (
                            <div className={styles.item} key={country}>
                                {isChina ? (
                                    <Link className={styles.itemLink} to={`${linkBase}/loc/beijing2022/honor`}>
                                        <div className={styles.itemProud}>
                                            {itemInner}
                                            <div className={styles.proudBtn}>
                                                <div className={styles.proudBtnText}>查看中国骄傲</div>
                                                <div className={styles.proudBtnArrow} />
                                            </div>
                                        </div>
                                    </Link>
                                ) : (
                                    itemInner
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default errorBoundary(List);
